import { Injectable } from '@angular/core';
import { HttpParams, HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { CalibrationSetAttribute } from '../../models/calibrations/calibration-set-attribute.model';

import { AttributeService } from './attribute.service';
import { CalibrationSetType } from '../../../shared/enums';
import { of } from 'rxjs';

const API = environment.ZONEIQ_CALIBRATION + '/v1/calibration-set-attribute';

@Injectable({
    providedIn: 'root'
})
export class CalibrationSetAttributeService extends AttributeService<CalibrationSetAttribute> {
    constructor(protected readonly http: HttpClient) {
        super(http, API, CalibrationSetAttribute);
    }

    getAttributesForCalibrationSet(calibrationSetId: number, calibrationSetType: CalibrationSetType) {
        if (!calibrationSetId) {
            return of([]);
        }

        const params = new HttpParams()
            .set('calibrationSetId', calibrationSetId.toString())
            .set('calibrationSetType', calibrationSetType.toString());

        return super.getByParameters(params);
    }
}
